import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-006bda34")

_pushScopeId("data-v-006bda34")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("We Recommend")
const _hoisted_2 = { class: "item-wrap" }
const _hoisted_3 = {
  class: "df-middle",
  ref: "domref",
  style: {"align-items":"stretch"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_TheRecommendItem = _resolveComponent("TheRecommendItem")
  const _component_HoldOn = _resolveComponent("HoldOn")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_t, {
      as: "p",
      path: "home_54",
      class: "f-bold mt-24 mb-8"
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_HoldOn, {
      content: $setup.list,
      height: 180
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: {'mr-12':index<$setup.list.length-1},
                ref: "domitem",
                style: {"align-items":"stretch"}
              }, [
                _createVNode(_component_TheRecommendItem, {
                  item: item,
                  style: {"height":"100%"}
                }, null, 8, ["item"])
              ], 2))
            }), 128))
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["content"])
  ], 64))
})